import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectValue } from '../select/select.model';

@Component({
  selector: 'oir-option-accordion',
  templateUrl: './option-accordion.component.html',
  styleUrls: ['./option-accordion.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionAccordionComponent {
  hasSelectedType = false;
  @Input() data: SelectValue<any>[];
  @Input() buttonText: string;
  @Input() placeholder: string;
  @Output() readonly modelChange: EventEmitter<any> = new EventEmitter();
  model;
  selectedDesc;

  public addSingleSelectDetails(): void {
    this.hasSelectedType = true;
    this.modelChange.emit(this.model);
    this.selectedDesc = this.data.find(x => x.value === this.model).title;
  }

  public onCancel(): void {
    this.model = undefined;
    this.hasSelectedType = false;
  }
}
